import styled, { css } from 'styled-components';
import { CustomTagManager } from '../utils/GTM';
import appIcon from './assets/app-icon.webp';

const BannerWrap = styled.div`
  display: flex;
  align-items: center;
  width: calc(100% - 32px);
  max-width: calc(480px - 32px);
  background: white;
  font-family: 'Pretendard', sans-serif;
  padding: 12px 16px;

  ${({ $isFixedTop }) =>
    $isFixedTop
      ? css`
          position: fixed;
          top: 0;
          left: 50%;
          transform: translateX(-50%);
        `
      : css`
          margin-bottom: 40px;
        `}

  img#app-icon {
    width: 44px;
    height: 44px;
    object-fit: contain;
  }

  p#app-banner-text {
    text-align: left;
    font-weight: 400;
    color: #42424a;
    margin-left: 10px;
    font-size: 14px;
    line-height: 20px;
    letter-spacing: -0.6px;
    white-space: pre-line;

    > b {
      font-weight: 600;
    }

    > .gradient {
      background: linear-gradient(92deg, #8f5ee9 5%, #3a99ff 80%);
      -webkit-background-clip: text;
      color: transparent;
    }
  }

  a#app-banner-link {
    font-size: 13px;
    font-weight: 500;
    line-height: 18px;
    letter-spacing: -0.6px;
    color: white;
    background: #202027;
    border: 1px solid #42424a;
    border-radius: 99px;
    padding: 7px 12px;
    text-decoration: none;
    margin-left: auto;
  }
`;

const AppBanner = ({ $isFixedTop = false, style }) => {
  return (
    <BannerWrap id="app-banner" $isFixedTop={$isFixedTop} style={style}>
      <img id="app-icon" src={appIcon} alt="PHOTOGRAY" />
      <p id="app-banner-text">
        앱에서 <b>스탬프 적립</b>하고
        <br />
        <b className="gradient">무료 쿠폰</b> 받아가세요!
      </p>
      <a
        id="app-banner-link"
        onClick={() =>
          CustomTagManager.QR_Download_Page_Banner_Ranking_Clicked()
        }
        href="https://4cut-ranking.com/app-download-redirect.html"
      >
        앱 설치하기
      </a>
    </BannerWrap>
  );
};

export default AppBanner;
